import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { deleteAllCookies, getCookie } from "./function";
import { connect } from "react-redux";
import { fetchApi } from "./api";
function PrivateRoute(props) {
  const [data, setData] = useState();
  const auth = getCookie("token");
  useEffect(() => {
    if (auth) {
      getDataProfile();
    } else {
      setData(true);
    }
  }, []);
  const getDataProfile = async () => {
    const req = await fetchApi("api/User/Details", "GET", true);
    const status = req.status;
    if (status === 200) {
      const res = await req.json();
      props._addProfile(res.data.auth);
      props._addSidebar(res.data.sidebar);
    } else {
      deleteAllCookies();
    }
    // props._addProfile({
    //     "email": "fauzi2@gmail.com",
    //     "role": "Super User",
    //     "approved": true,
    //     "isLogin": true,
    //     "isReject": false,
    //     "isWaiting": false,
    //     "isMustChangePass": false,
    //     "lastLogin": 1661078579262
    // })
    // BELOW WAS ACTIVE
    // props._addSidebar([
    //   {
    //     _id: "6303035762962bca065ae0cf",
    //     name: "Dashboard",
    //     path: "/dashboard",
    //     submenu: [],
    //     icon: "las la-chart-bar",
    //   },
    //   {
    //     _id: "6303048262962bca065ae0d1",
    //     name: "User Management",
    //     path: "#",
    //     submenu: [
    //       {
    //         name: "User",
    //         path: "/user-management/user",
    //       },
    //       {
    //         name: "Role",
    //         path: "/user-management/role",
    //       },
    //     ],
    //     icon: "las la-user-cog",
    //   },
    //   {
    //     _id: "630305d862962bca065ae0d2",
    //     name: "Pemantauan Sensor",
    //     path: "/sensor-monitor",
    //     submenu: [],
    //     icon: "las la-project-diagram",
    //   },
    //   {
    //     _id: "630305fd62962bca065ae0d3",
    //     name: "Pemantauan Struktur",
    //     path: "/structure-monitor",
    //     submenu: [],
    //     icon: "lab la-chromecast",
    //   },
    //   {
    //     _id: "6303061b62962bca065ae0d4",
    //     name: "Sistem Audit",
    //     path: "/sistem-audit",
    //     submenu: [],
    //     icon: "las la-user-clock",
    //   },
    //   {
    //     _id: "6303063762962bca065ae0d5",
    //     name: "Field Report",
    //     path: "/field-report",
    //     submenu: [],
    //     icon: "las la-camera",
    //   },
    // ]);
    setData(true);
  };
  if (data) {
    return auth ? props.children : <Navigate to="/login" />;
  } else {
    return <p className="text-center">Loading...</p>;
  }
}
const mapState = (state) => {
  return {};
};

const actionCreators = (dispatch) => {
  return {
    _addProfile: (data) => dispatch({ type: "ADD_PROFILE", payload: data }),
    _addSidebar: (data) => dispatch({ type: "ADD_SIDEBAR", payload: data }),
  };
};
export default connect(mapState, actionCreators)(PrivateRoute);
